import {
  ActionReducerMap,
  createFeatureSelector,
  createSelector, MemoizedSelector,
} from '@ngrx/store';
import * as _ from 'lodash';
import * as fromRoot from '../../shared/reducers';
import {ContractsListReducer, contractsListSelectors, ContractsState} from './contarcts-list';
import {ContractFilter} from '../models/contract-filter';
import {ContractItem} from '../models/contract-item';
import {Contract} from '../models/contract';
import {ContractReducer, contractSelectors, ContractState} from './contract';
import {RulesReducer, rulesSelectors, RulesState} from './rules';
import {Rules} from '../models/rules';
import {currenciesSelectors, CurrencyReducer, CurrencyState} from './currency';
import {CurrencyObject} from '../models/currency';
import {LanguageTextsReducer, languageTextsSelectors, LanguageTextsState} from './language-texts';
import {LanguageText} from '../models/language-text';

export interface AppState extends fromRoot.AppState {
  contracts: ContractsState;
}

export interface ContractsStates {
  contract: ContractState;
  rules: RulesState;
  contractsList: ContractsState;
  currency: CurrencyState;
  languageFeeTexts: LanguageTextsState;
  languageGlobalTexts: LanguageTextsState;
  languageReplacementTexts: LanguageTextsState;
  LanguageID: LanguageTextsState;
}

export const reducers: ActionReducerMap<ContractsStates> = {
  contract: ContractReducer,
  rules: RulesReducer,
  contractsList: ContractsListReducer,
  currency:  CurrencyReducer,
  languageFeeTexts:  LanguageTextsReducer,
  languageGlobalTexts:  LanguageTextsReducer,
  languageReplacementTexts:  LanguageTextsReducer,
  LanguageID:  LanguageTextsReducer,
};

const getContractState = createFeatureSelector('contracts');

const rootSelectors = {
  contract: createSelector(getContractState, (state: ContractsStates) => _.get(state, 'contract')),
  rules: createSelector(getContractState, (state: ContractsStates) => _.get(state, 'rules')),
  contractsList: createSelector(getContractState, (state: ContractsStates) => _.get(state, 'contractsList')),
  currency: createSelector(getContractState, (state: CurrencyState) => _.get(state, 'currency')),
  languageFeeTexts: createSelector(getContractState, (state: LanguageTextsState) => _.get(state, 'languageFeeTexts')),
  languageGlobalTexts: createSelector(getContractState, (state: LanguageTextsState) => _.get(state, 'languageGlobalTexts')),
  languageReplacementTexts: createSelector(getContractState, (state: LanguageTextsState) => _.get(state, 'languageReplacementTexts')),
  LanguageID: createSelector(getContractState, (state: LanguageTextsState) => _.get(state, 'LanguageID')),
};

export interface Selectors {
  getRules: MemoizedSelector<AppState, Rules[]>;
  getCurrentContract: MemoizedSelector<AppState, Contract>;
  getContractFilter: MemoizedSelector<AppState, ContractFilter |  string | number>;
  getContractQuickSearch: MemoizedSelector<AppState, string>;
  getContractBy: MemoizedSelector<AppState, string>;
  getContracts: MemoizedSelector<AppState, ContractItem[]>;
  getContractCount: MemoizedSelector<AppState, number>;
  getContractPageSize: MemoizedSelector<AppState, number>;
  getContractPage: MemoizedSelector<AppState, number>;
  getContractShowFilter: MemoizedSelector<AppState, boolean>;
  getCurrencies: MemoizedSelector<AppState, CurrencyObject[]>;
  getFeeLanguageTexts: MemoizedSelector<AppState, LanguageText[]>;
  getGlobalLanguageTexts: MemoizedSelector<AppState, LanguageText[]>;
  getReplacementLanguageTexts: MemoizedSelector<AppState, LanguageText[]>;
  getLanguageID: MemoizedSelector<AppState, number>;
}

export const selectors: Selectors = {
  getRules: createSelector(rootSelectors.rules, rulesSelectors.rules),
  getCurrentContract: createSelector(rootSelectors.contract, contractSelectors.contract),
  getContractFilter: createSelector(rootSelectors.contractsList, contractsListSelectors.filter),
  getContractQuickSearch: createSelector(rootSelectors.contractsList, contractsListSelectors.quickSearch),
  getContractBy: createSelector(rootSelectors.contractsList, contractsListSelectors.orderBy),
  getContracts: createSelector(rootSelectors.contractsList, contractsListSelectors.array),
  getContractCount: createSelector(rootSelectors.contractsList, contractsListSelectors.count),
  getContractPageSize: createSelector(rootSelectors.contractsList, contractsListSelectors.pageSize),
  getContractPage: createSelector(rootSelectors.contractsList, contractsListSelectors.page),
  getContractShowFilter: createSelector(rootSelectors.contractsList, contractsListSelectors.showFilter),
  getCurrencies: createSelector(rootSelectors.currency, currenciesSelectors.array),
  getFeeLanguageTexts: createSelector(rootSelectors.languageFeeTexts, languageTextsSelectors.fee),
  getGlobalLanguageTexts: createSelector(rootSelectors.languageGlobalTexts, languageTextsSelectors.global),
  getReplacementLanguageTexts: createSelector(rootSelectors.languageReplacementTexts, languageTextsSelectors.replacement),
  getLanguageID: createSelector(rootSelectors.LanguageID, languageTextsSelectors.languageId),
};

